import styled from 'styled-components'

export const HeaderContainer = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0px;
  height: 100%;
  padding: 10px;
  padding-left: 40px;
  padding-right: 40px;
  height: 70px;
  width: 100vw;
  margin: 0px;
  background-color: ${props => (props.theme === true ? '#212121' : '#f9f9f9')};
  @media screen and (max-width: 767px) {
    postion: fixed;
    top: 0px;
    padding: 4px;
    padding-left: 8px;
    padding-right: 8px;
    height: 50px;
    width: 100%;
  }
`

export const WebsiteLogo = styled.img`
  height: 38px;
  width: 155px;
  @media screen and (max-width: 767px) {
    height: 22px;
    width: 80px;
  }
`

export const ThemeImg = styled.button`
  display: flex;
  align-items: center;
  outline: none;
  cursor: pointer;
  border: none;
  margin-right: 10px;
  background: transparent;
  @media screen and (max-width: 767px) {
    margin-right: 4px;
  }
`

export const LogoutButton = styled.button`
  height: 35px;
  width: 130px;
  cursor: pointer;
  outline: none;
  font-family: 'Roboto';
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  font-size: 22px;
  font-weight: 400;
  font-family: 'Roboto';
  background: transparent;
  border-color: ${props => (props.theme === true ? '#ebebeb' : '#00306e')};
  color: ${props => (props.theme === true ? '#ebebeb' : '#00306e')};
  @media screen and (max-width: 767px) {
    display: none;
  }
`

export const NavElements = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
  @media screen and (max-width: 767px) {
    margin-right: 4px;
  }
`

export const Icon = styled.i`
  height: 38px;
  width: 39px;
  color: ${props => (props.theme === true ? '#ffffff' : '#000000')};
  @media screen and (max-width: 767px) {
    height: 22px;
    width: 23px;
  }
`

export const ProfileImg = styled.img`
  height: 39px;
  width: 39px;
  margin-right: 8px;
  @media screen and (max-width: 767px) {
    height: 22px;
    width: 23px;
  }
`

export const CardHeading = styled.p`
  color: ${props => (props.theme === true ? '#ffffff' : '#3b82f6')};
  font-family: 'Roboto';
  font-weight: 600;
  font-size: 22px;
  text-align: center;
  margin-bottom: 24px;
  @media screen and (max-width: 767px) {
    font-size: 15px;
    margin-bottom: 18px;
  }
`

export const PopupEl = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${props => (props.theme === true ? '#313131' : '#ffffff')};
  width: 400px;
  max-width: 1100px;
  padding: 20px;
  border: none;
  border-radius: 8px;
  @media screen and (max-width: 767px) {
    min-width: 150px;
    max-width: 290px;
    padding: 8px;
    border-radius: 4px;
  }
`

export const PopupButton = styled.button`
    height:40px;
    width:88px;
    text-align:center;
    padding:3px;
    font-size:16px;
    border:none;
    cursor:pointer;
    outline:none; 
    border-radius:5px;
    border-width:1px;
    border-style:solid;       
    color:${props => (props.theme === true ? '#7e858e' : '#ffffff')};
    color:${props => (props.outline === true ? '#7e858e' : '#ffffff')};
    border-color:${props => (props.theme === true ? '#7e858e' : '#ffffff')};
    background-color:${props =>
      props.outline === true ? '#313131' : '#3b82f6'};
      
    @media screen and (max-width:767px){
        height:28px;
        width:60px;
        padding:1px; 
        font-size:10px
        border-radius:3px;   
    }
`

export const DThemeImg = styled(ThemeImg)`
  @media screen and (min-width: 767px) {
    display: none;
  }
`
